module.exports = __webpack_public_path__ + "static/media/35.e42927a9.svg";